<div class="flex flex-col items-stretch gap-16 min-w-max h-fit">
  <div class="flex-1 bg-neutral-100 min-h-max aspect-square animate-pulse" />
  <div class="w-full h-24 bg-neutral-100 animate-pulse" />
  <div class="w-1/2 h-24 bg-neutral-100 animate-pulse" />
  <div class="w-full h-16 bg-neutral-100 animate-pulse" />
  <div class="w-full h-16 bg-neutral-100 animate-pulse" />
  <div class="w-1/3 h-16 bg-neutral-100 animate-pulse" />
</div>
